import { COACHING_INSIGHTS } from './insights';

export const COACHING_TYPES = {
  business: {
    title: 'Your AI Business Coach',
    displayName: 'Business Coach',
    subtitle: 'Strategic guidance for growth',
    placeholder: 'Ask about scaling, delegation, or business frameworks...',
    quickStart: [
      "What's my biggest bottleneck right now?",
      'How should I structure my team for growth?',
      'What systems should I implement next?'
    ],
    manualSuggestions: ['Revenue goals', 'Team challenges', 'Growth targets'],
    tools: COACHING_INSIGHTS.business.tools
  },
  mentormind: {
    title: 'AI Business Growth Coach',
    displayName: 'Business Growth Coach',
    subtitle: 'Strategic business growth with proven frameworks',
    placeholder: 'Ask about scaling, delegation, or business frameworks...',
    quickStart: [
      "We're doing $2M ARR with 15 people, but I'm working 70-hour weeks",
      "I want to hire a COO but not sure if it's the right time",
      "My team always comes to me with problems instead of solutions",
      "Calculate the ROI of hiring an executive assistant",
      "Help me build a delegation ladder for my current role",
      "What's the biggest bottleneck preventing us from scaling?"
    ],
    manualSuggestions: ['Revenue goals', 'Team challenges', 'Growth strategies', 'Scaling challenges'],
    tools: [] // Tools are now loaded dynamically from the backend API via /api/v1/frameworks
  },
  health: {
    title: 'Your AI Fitness Coach',
    displayName: 'Health & Fitness Coach',
    subtitle: 'Personalized fitness and nutrition guidance',
    placeholder: 'Ask about workouts, nutrition, or fitness goals...',
    quickStart: [
      'Create a workout plan for my goals',
      'What should my nutrition look like?',
      'Help me build healthy habits'
    ],
    manualSuggestions: ['Fitness goals', 'Nutrition challenges', 'Weight targets'],
    tools: COACHING_INSIGHTS.health.tools
  },
  ecommerce: {
    title: 'Your AI E‑Commerce Coach',
    displayName: 'E-Commerce Coach',
    subtitle: 'Optimize your online business',
    placeholder: 'Ask about products, marketing, or conversion...',
    quickStart: ['Analyze my product profitability', 'Optimize my ad spend', 'Improve my conversion rate'],
    manualSuggestions: ['Sales targets', 'Product challenges', 'Marketing goals'],
    tools: COACHING_INSIGHTS.ecommerce.tools
  },
  life: {
    title: 'Your AI Life Coach',
    displayName: 'Life Coach',
    subtitle: 'Guidance for personal growth',
    placeholder: 'Ask about goals, habits, or balance...',
    quickStart: ['Help me clarify my core values', 'Create a morning routine', 'Balance work and personal life'],
    manualSuggestions: ['Life goals', 'Personal challenges', 'Happiness targets'],
    tools: COACHING_INSIGHTS.life.tools
  },
  career: {
    title: 'Your AI Career Coach',
    displayName: 'Career Coach',
    subtitle: 'Advance your professional journey',
    placeholder: 'Ask about career goals, skills, or job search...',
    quickStart: ['Plan my next career move', 'Improve my resume', 'Prepare for interviews'],
    manualSuggestions: ['Career goals', 'Skill gaps', 'Job search targets'],
    tools: COACHING_INSIGHTS.career.tools
  },
  relationship: {
    title: 'Your AI Relationship Coach',
    displayName: 'Relationship Coach',
    subtitle: 'Improve your connections',
    placeholder: 'Ask about communication, boundaries, or relationships...',
    quickStart: ['Improve communication with my partner', 'Set healthy boundaries', 'Handle relationship conflicts'],
    manualSuggestions: ['Relationship goals', 'Communication challenges', 'Boundary needs'],
    tools: COACHING_INSIGHTS.relationship.tools
  },
  financial: {
    title: 'Your AI Financial Coach',
    displayName: 'Financial Coach',
    subtitle: 'Build wealth and financial freedom',
    placeholder: 'Ask about budgeting, investing, or debt...',
    quickStart: ['Create a budget plan', 'Pay off my debt faster', 'Start investing wisely'],
    manualSuggestions: ['Financial goals', 'Debt challenges', 'Investment targets'],
    tools: COACHING_INSIGHTS.financial.tools
  },
  leadership: {
    title: 'Your AI Leadership Coach',
    displayName: 'Leadership Coach',
    subtitle: 'Develop your leadership',
    placeholder: 'Ask about teams, decisions, or ops...',
    quickStart: ['Develop my leadership style', 'Build a high‑performing team', 'Make better decisions'],
    manualSuggestions: ['Leadership goals', 'Team challenges', 'Development needs'],
    tools: COACHING_INSIGHTS.leadership.tools
  },
  sales: {
    title: 'Your AI Sales Coach',
    displayName: 'Sales Coach',
    subtitle: 'Boost your sales performance',
    placeholder: 'Ask about pipeline, closing, or objections...',
    quickStart: ['Improve my close rate', 'Build my pipeline', 'Handle objections better'],
    manualSuggestions: ['Sales goals', 'Pipeline challenges', 'Performance targets'],
    tools: COACHING_INSIGHTS.sales.tools
  }
};

export const getCoachingConfig = (type, verticalOverrides = {}) => {
  const base = COACHING_TYPES[type] || COACHING_TYPES.business;
  const merged = {
    title: base.title,
    displayName: base.displayName || base.title.replace('Your AI ', '').replace('AI ', ''),
    subtitle: base.subtitle,
    placeholder: base.placeholder,
    quickStart: base.quickStart,
    manualSuggestions: base.manualSuggestions,
    tools: base.tools,
  };
  if (verticalOverrides && verticalOverrides.tools) {
    merged.tools = verticalOverrides.tools;
  }
  return merged;
};


